/* unplugin-vue-components disabled */import { render } from "./CollateralNode.vue?vue&type=template&id=91459b0c"
import script from "./CollateralNode.vue?vue&type=script&lang=js"
export * from "./CollateralNode.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__